'use strict';

var React              = require('react'),
    ScheduleRange      = require('./schedule-range.jsx');;

var Schedule = React.createClass({
  propTypes: {
    firebaseUrl: React.PropTypes.string.isRequired
  },

  render: function() {

    var workshops = null;
    if (false) {
      workshops = (
        <a
        href="https://docs.google.com/spreadsheets/d/19nSUvjLAhQjjg5w_OVovfNHEHXQ4e7gq8rvrumg3jig">
          <div className="sponsor-button htn-button">Workshop Schedule</div>
        </a>
      );
    }

    return (
      <div>
        <h2 className="section-title">Schedule</h2>

        <h3 className="section-subtitle">Friday, Sept 18th</h3>
        <ScheduleRange
          startAt="2015-09-18T00:00:00"
          endAt="2015-09-18T23:59:59"
          firebaseUrl={this.props.firebaseUrl} />

        <h3 className="section-subtitle">Saturday, Sept 19th</h3>
        <ScheduleRange
          startAt="2015-09-19T00:00:00"
          endAt="2015-09-19T23:59:59"
          firebaseUrl={this.props.firebaseUrl} />

        <h3 className="section-subtitle">Sunday, Sept 20th</h3>
        <ScheduleRange
          startAt="2015-09-20T00:00:00"
          endAt="2015-09-20T23:59:59"
          firebaseUrl={this.props.firebaseUrl} />

        {workshops}
      </div>
    );
  }
});

module.exports = Schedule;



/** WEBPACK FOOTER **
 ** ./js/screens/main-2015/schedule.jsx
 **/